<script setup lang="ts">
import '@/assets/scss/styles.scss';
</script>

<template>
  <RouterView />
</template>

<style scoped>

</style>

